import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudGastosOrtopediaByID = {
  status: number | null;
  statusText: string | null;
};

const getBackendMessage = (err: any) => {
  const responseData = err?.response?.data;

  return (
    (typeof responseData === "string" ? responseData : null) ||
    responseData?.response ||
    responseData?.message ||
    err?.response?.statusText ||
    err?.message ||
    "Error"
  );
};

const useGetSolicitudGastosOrtopediaByID = () => {
  const [loadingGetSolicitudGastosOrtopediaByID, setLoadingGetSolicitudGastosOrtopediaByID] = useState(false);
  const [successGetSolicitudGastosOrtopediaByID, setSuccessGetSolicitudGastosOrtopediaByID] = useState(false);
  const [errorGetSolicitudGastosOrtopediaByID, setErrorGetSolicitudGastosOrtopediaByID] = useState<any>(null);
  const [dataGetSolicitudGastosOrtopediaByID, setDataSolicitudGastosOrtopedia] = useState<any>(null);
  const [statusGetSolicitudGastosOrtopediaByID, setStatusGetSolicitudGastosOrtopediaByID] =
    useState<StatusGetSolicitudGastosOrtopediaByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getSolicitudGastosOrtopediaByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudGastosOrtopediaByID(true);
    setSuccessGetSolicitudGastosOrtopediaByID(false);
    setErrorGetSolicitudGastosOrtopediaByID(null);

    try {
      const res = await apiRecord.getSolicitudGastosContingenciaProfesionalOrtopediaByID(userId, prestacionId, id);

      setStatusGetSolicitudGastosOrtopediaByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudGastosOrtopediaByID(true);
      setDataSolicitudGastosOrtopedia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      const backendMessage = getBackendMessage(err);

      setStatusGetSolicitudGastosOrtopediaByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudGastosOrtopediaByID(err);
      console.error("Error en getSolicitudGastosOrtopediaByID:", err);

      throw err;
    } finally {
      setLoadingGetSolicitudGastosOrtopediaByID(false);
    }
  };

  return {
    getSolicitudGastosOrtopediaByID,
    loadingGetSolicitudGastosOrtopediaByID,
    successGetSolicitudGastosOrtopediaByID,
    errorGetSolicitudGastosOrtopediaByID,
    dataGetSolicitudGastosOrtopediaByID,
    statusGetSolicitudGastosOrtopediaByID
  };
};

export default useGetSolicitudGastosOrtopediaByID;
